import React from "react";
import ViewProfileMain from "../../../components/auth/view-profile/ViewProfileMain";
import Sidebar from "../../../components/common/Sidebar";
import { RODEO_PAGE_NAME } from "../../../_config";

const ViewProfilePage: React.FC = () => {
  return (
    <>
      <Sidebar page={RODEO_PAGE_NAME.VIEW_PROFILE} />
      <ViewProfileMain />
    </>
  );
};

export default ViewProfilePage;